document.addEventListener("DOMContentLoaded", () => {
  const quantityInput =
    document.querySelector("quantity-selector-component input[name='quantity']") ||
    document.querySelector("input[name='quantity']");

  const shippingDiv = document.getElementById("shipping-estimate");

  if (!quantityInput || !shippingDiv) return;

  function setShippingMessage(qty) {
    const stock = window.activeInventory ?? 0;

    if (stock >= qty && stock > 0) {
      shippingDiv.textContent = "📦 Isporuka: 2 – 5 radnih dana";
      shippingDiv.style.color = "#03C565";
    } else {
      shippingDiv.textContent = "📦 Isporuka: 7 – 10 radnih dana";
      shippingDiv.style.color = "#03C565";
    }
  }

  // početna vrijednost
  let lastQty = parseInt(quantityInput.value, 10) || 1;
  setShippingMessage(lastQty);

  // svakih 150 ms provjeravamo je li se količina promijenila
  setInterval(() => {
    const currentQty = parseInt(quantityInput.value, 10) || 1;
    if (currentQty !== lastQty) {
      lastQty = currentQty;
      setShippingMessage(currentQty);
    }
  }, 150);
});
